import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { CarouselSlideDirective } from '@df/ui-carousel/carousel-slide.directive';
import { CarouselComponent } from '@df/ui-carousel/carousel.component';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, type NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { AbstractCmsBlockComponent } from '../../../../../cms/block/abstract-cms-block.component';

export interface IProductUspBlockDataContent extends NICmsContentComponent.IData {
    title?: string;
    slides: IUspComponentSlide[];
}

export interface IUspComponentSlide {
    image?: string;
    title: string;
    copy: string;
    link?: string;
}

@Component({
    selector: 'product-layout-usp-block',
    templateUrl: './product-layout-usp-block.component.html',
    styleUrl: './product-layout-usp-block.component.scss',
    imports: [CarouselComponent, CarouselSlideDirective, DfImageDirective, HrefComponent, ICmsClientModule, SizeClassDirective],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<ProductLayoutUspBlockComponent>({
    id: 'usp-block',
    block: {
        url: 'usp-block'
    },
    onDemandOnly: true,
    name: 'usp-block',
    fields: [
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.text,
            key: 'title',
            title: 'Title'
        },
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'slides',
            title: 'Slides',
            itemName: 'Slide',
            itemNameField: 'title',
            maxSize: 4,
            fields: [
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.image,
                    key: 'image',
                    title: 'Image'
                },
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.text,
                    key: 'title',
                    title: 'Title',
                    required: true
                },
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.text,
                    key: 'copy',
                    title: 'Copy',
                    required: true
                },
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.text,
                    key: 'link',
                    title: 'Link'
                }
            ],
            default: []
        }
    ]
})
export class ProductLayoutUspBlockComponent extends AbstractCmsBlockComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    override content!: IProductUspBlockDataContent;

    protected readonly uid = `product-usp-block-${crypto.randomUUID()}`;
    protected readonly spaceBetween = 8;
    protected readonly slidesPerView = [1.3, 1.3, 1.5, 1.5][this.client.sizeId];
    protected readonly slidesPerViewRound = Math.round(this.slidesPerView);
}
